<template>
  <div class="table-responsive"id="tableAll" >
    <table  class="table table-bordered table-all">
      <thead>
      <tr align="center">
        <th style="width: 30px;">No</th>
        <th style="min-width: 160px;">
          Account Name
          <b-badge pill variant="primary">{{detailDown.length}}</b-badge>
        </th>
        <th>Address</th>
        <th style="min-width: 200px;"> Down Time
          <b-badge pill variant="primary" >{{total}}</b-badge>
        </th>
        <th style="min-width: 300px;" >Duration <br>
          <b-badge pill variant="primary" >( Avg: {{average | convertSecond}})</b-badge>

        </th>
        <th>Notes</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(detail, index) in detailDown">
        <tr>
          <td :rowspan="detail.data.length" style="width: 10px;">{{index + 1}}</td>
          <td :rowspan="detail.data.length">{{detail.cust_acc_name}}</td>
          <td :rowspan="detail.data.length">{{detail.installation_address}} <br>
            <strong>Activation Date:</strong> {{detail.cust_activation_date}}
          </td>
          <template v-if="detail.data">
            <td> {{detail.data[0].start_time}}</td>
            <td>{{detail.data[0].duration | convertSecond}}</td>
            <template v-if="detail.data[0].subject">
              <td>{{detail.data[0].subject}} </td>
            </template>
            <template v-else-if="detail.data[0].problem">
              <td>{{detail.data[0].problem}}
                <br>
                {{detail.data[0].cause}}
              </td>
            </template>
          </template>
          <template v-else>
            <td></td>
            <td></td>
            <td></td>
            <td></td>

          </template>
        </tr>
        <template v-if="detail.data_count > 1">
          <template v-for="(downtime, i) in detail.data" v-if="i > 0">
            <tr>
              <td> {{downtime.start_time}}</td>
              <td>{{downtime.duration | convertSecond}}</td>
              <template v-if="downtime.subject">
                <td>{{downtime.subject}}</td>
              </template>
              <template v-else-if="downtime.problem">
                <td>{{downtime.problem}} <br>
                  {{downtime.cause}}</td>
              </template>
            </tr>
          </template>
        </template>

      </template>
      </tbody>
    </table>
  </div>
</template>
<script>
  export default {
    props: {
      detailDown: {
        type: Array,
        default: []
      },
      total: {
        type: Number,
        default: 0
      },
      average: {
        type: Number,
        default: 0
      }
    }
  }
</script>
